import {
  post_data,
  removeErrorMessage,
  showErrorMessage,
} from "../helpers/functions";

export default function forgotten_password_page() {
  if (window.location.href.indexOf("/forgotten_password") === -1) return;
  const email = document.querySelector(".email");
  const resetPassword = document.getElementById("reset_submit");
  const container = document.querySelector(".form-container");
  resetPassword.addEventListener("click", async () => {
    if (email.value === "") return showErrorMessage('Field can\'t be empty.'); // prettier-ignore
    document.querySelector(".loader").classList.add("active");
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "forgotten_password",
        email: email.value,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    if (response.valid === 0) return showErrorMessage(response.msg);
    container.innerHTML = "";
    const message = document.createElement("p");
    Object.assign(message, {
      className: "input-container text-center",
      textContent:
        "Thank you for reaching out! We have sent you an e-mail with the password reset link. ",
    });
    const goBack = document.createElement("a");
    Object.assign(goBack, {
      className: "btn btn-primary w-100 mt-4",
      href: "./",
      textContent: "OK",
    });
    container.append(message);
    container.append(goBack);
    document.querySelector(".loader").classList.remove("active");
  });
  email.addEventListener("focus", removeErrorMessage);
}
